import React from 'react';
import { Card } from '../../components/ui/Card';

export default function UserPermissions() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900">User Permissions</h2>
        <p className="text-sm text-gray-500 mt-1">Manage user roles and access permissions</p>
      </div>

      <Card className="p-6">
        <div className="space-y-6">
          <div>
            <h3 className="text-sm font-medium text-gray-900">Coming Soon</h3>
            <p className="text-sm text-gray-500 mt-1">
              User permissions management will be available soon.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
} 